import React, { useState } from 'react';
import { Handle, Position, NodeProps, useReactFlow } from '@xyflow/react';
import { GitMerge, X } from 'lucide-react';
import { MergeNodeData } from '../types';

export function MergeNode({ id, data: rawData, selected }: NodeProps) {
  const data = rawData as unknown as MergeNodeData;
  const [isHovered, setIsHovered] = useState(false);
  const { setNodes, setEdges } = useReactFlow();

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    setNodes((nodes) => nodes.filter((n) => n.id !== id));
    setEdges((edges) => edges.filter((e) => e.source !== id && e.target !== id));
  };

  return (
    <div
      className={`relative min-w-[140px] rounded-xl border-2 bg-white shadow-lg transition-all ${
        selected ? 'border-teal-500 shadow-teal-200' : 'border-teal-400'
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Delete button on hover */}
      {isHovered && (
        <button
          onClick={handleDelete}
          className="absolute -top-2 -right-2 z-10 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-white shadow-md hover:bg-red-600 transition-colors"
          title="Delete node"
        >
          <X size={12} />
        </button>
      )}
      {/* Multiple target handles for incoming branches */}
      <Handle
        type="target"
        position={Position.Top}
        id="merge-in-1"
        className="!bg-teal-500 !w-3 !h-3"
        style={{ left: '30%' }}
      />
      <Handle
        type="target"
        position={Position.Top}
        id="merge-in-2"
        className="!bg-teal-500 !w-3 !h-3"
        style={{ left: '70%' }}
      />
      <div className="flex items-center gap-2 rounded-t-xl bg-teal-500 px-3 py-2">
        <GitMerge size={14} className="text-white" />
        <span className="text-xs font-semibold uppercase tracking-wider text-white">Merge</span>
      </div>
      <div className="px-3 py-2 text-center">
        <p className="text-sm font-medium text-gray-600 dark:text-gray-300">
          {data.label || 'Converge paths'}
        </p>
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-teal-500 !w-3 !h-3" />
    </div>
  );
}
